<template>
  <div class="air-tabs flex jbetween acenter">
    <template v-for="(tab, index) in tabs">
      <div v-if="index > 0" class="divider"></div>
      <div class="air-tabs-item pointer" :class="{ active: active === tab.value }" @click="changeTab(tab)">
        <span>{{ tab.label }}</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'airTabs',
  emits: ['tab-click', 'update:active'],
  props: {
    active: {
      type: [String, Number],
      default: 'tab1'
    },
    tabs: {
      type: Array,
      default () {
        return [
          {
            label: '标签1',
            value: 'tab1'
          }
        ]
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    changeTab(tab) {
      this.$emit('update:active', tab.value)
      this.$emit('tab-click', tab)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/common.scss";

.air-tabs {
  .air-tabs-item {
    span {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3E475D;
      line-height: 20px;
    }
    &.active {
      span {
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #2A61FF;
      }
    }
  }
  .divider {
    width: 1px;
    height: 12px;
    border-radius: 1px;
    background-color: #999999;
    margin: 0 18px;
  }
}
</style>
